import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Badge } from '../ui/badge';
import { TabsContent } from '../ui/tabs';
import { Switch } from '../ui/switch';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import VoiceInput from '../VoiceInput';
import ImportarTarefasIA from '../ImportarTarefasIA';
import { Plus, Trash2, Repeat } from 'lucide-react';
import {
  formatDate,
  todayLocal,
  TASK_TYPE_LABELS,
  TASK_STATUS_LABELS,
  PRIORITY_LABELS,
  PRIORITY_COLORS
} from '../../lib/utils';

export const TabTarefas = ({
  tarefas,
  tarefaFilter,
  setTarefaFilter,
  tarefaModalOpen,
  setTarefaModalOpen,
  novaTarefa,
  setNovaTarefa,
  usuarios,
  tarefasHoje,
  tarefasVencidas,
  handleCreateTarefa,
  handleUpdateTarefaStatus,
  handleDeleteTarefa,
  fetchData
}) => (
  <TabsContent value="tarefas">
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <CardTitle>Tarefas</CardTitle>
          <CardDescription>Visitas, procedimentos, entregas e pendências</CardDescription>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
            <Button 
              variant={tarefaFilter === 'todas' ? 'default' : 'ghost'} 
              size="sm"
              onClick={() => setTarefaFilter('todas')}
              data-testid="filter-todas"
            >
              Todas
            </Button>
            <Button 
              variant={tarefaFilter === 'hoje' ? 'default' : 'ghost'} 
              size="sm"
              onClick={() => setTarefaFilter('hoje')}
              className={tarefaFilter === 'hoje' ? 'bg-blue-600 hover:bg-blue-700' : ''}
              data-testid="filter-hoje"
            >
              Hoje ({tarefasHoje})
            </Button>
            <Button 
              variant={tarefaFilter === 'vencidas' ? 'default' : 'ghost'} 
              size="sm"
              onClick={() => setTarefaFilter('vencidas')}
              className={tarefaFilter === 'vencidas' ? 'bg-red-600 hover:bg-red-700' : tarefasVencidas > 0 ? 'text-red-600' : ''}
              data-testid="filter-vencidas"
            >
              Vencidas ({tarefasVencidas})
            </Button>
          </div>
        </div>
        <div className="flex gap-2">
          <ImportarTarefasIA onImportComplete={() => fetchData()} />
          <Dialog open={tarefaModalOpen} onOpenChange={setTarefaModalOpen}>
            <DialogTrigger asChild>
              <Button data-testid="btn-nova-tarefa">
                <Plus className="h-4 w-4 mr-2" />
                Nova Tarefa
              </Button>
            </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Nova Tarefa</DialogTitle>
              <DialogDescription>Adicione uma nova tarefa para este paciente</DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Título *</Label>
                <div className="flex gap-2">
                  <Input
                    id="tarefa-titulo"
                    placeholder="Título da tarefa"
                    value={novaTarefa.titulo}
                    onChange={(e) => setNovaTarefa({...novaTarefa, titulo: e.target.value})}
                    data-testid="input-tarefa-titulo"
                    className="flex-1"
                  />
                  <VoiceInput 
                    targetInputId="tarefa-titulo"
                    onTranscript={(text) => setNovaTarefa({...novaTarefa, titulo: text})}
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Tipo</Label>
                  <Select 
                    value={novaTarefa.tipo}
                    onValueChange={(v) => setNovaTarefa({...novaTarefa, tipo: v})}
                  >
                    <SelectTrigger data-testid="select-tarefa-tipo">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {Object.entries(TASK_TYPE_LABELS).map(([value, label]) => (
                        <SelectItem key={value} value={value}>{label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label>Prioridade</Label>
                  <Select 
                    value={novaTarefa.prioridade}
                    onValueChange={(v) => setNovaTarefa({...novaTarefa, prioridade: v})}
                  >
                    <SelectTrigger data-testid="select-tarefa-prioridade">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {Object.entries(PRIORITY_LABELS).map(([value, label]) => (
                        <SelectItem key={value} value={value}>{label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="space-y-2">
                <Label>Data {novaTarefa.recorrente ? 'Início' : 'Prevista'}</Label>
                <Input
                  type="date"
                  value={novaTarefa.data_prevista}
                  onChange={(e) => setNovaTarefa({...novaTarefa, data_prevista: e.target.value})}
                  data-testid="input-tarefa-data"
                />
              </div>
              
              {/* Recurrence Options */}
              <div className="space-y-3 p-3 border rounded-lg bg-muted/30">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Repeat className="h-4 w-4 text-muted-foreground" />
                    <Label className="font-medium">Tarefa Recorrente</Label>
                  </div>
                  <Switch
                    checked={novaTarefa.recorrente}
                    onCheckedChange={(checked) => setNovaTarefa({...novaTarefa, recorrente: checked})}
                  />
                </div>
                
                {novaTarefa.recorrente && (
                  <div className="space-y-3 pt-2 border-t">
                    <div className="space-y-2">
                      <Label>Repetir a cada X dias</Label>
                      <Input
                        type="number"
                        min="1"
                        max="365"
                        value={novaTarefa.recorrencia_dias}
                        onChange={(e) => setNovaTarefa({...novaTarefa, recorrencia_dias: e.target.value})}
                        className="w-24"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="space-y-2">
                        <Label>Data Fim (opcional)</Label>
                        <Input
                          type="date"
                          value={novaTarefa.data_fim}
                          onChange={(e) => setNovaTarefa({...novaTarefa, data_fim: e.target.value, num_ocorrencias: ''})}
                          min={novaTarefa.data_prevista}
                        />
                      </div>
                      <div className="space-y-2">
                        <Label>Ou Nº Ocorrências</Label>
                        <Input
                          type="number"
                          min="1"
                          max="100"
                          placeholder="Ex: 10"
                          value={novaTarefa.num_ocorrencias}
                          onChange={(e) => setNovaTarefa({...novaTarefa, num_ocorrencias: e.target.value, data_fim: ''})}
                          className="w-24"
                        />
                      </div>
                    </div>
                    <p className="text-xs text-muted-foreground">
                      Se não informar fim ou nº de ocorrências, serão criadas tarefas para 30 dias.
                    </p>
                  </div>
                )}
              </div>
              
              <div className="space-y-2">
                <Label>Responsável</Label>
                <Select 
                  value={novaTarefa.responsavel_id}
                  onValueChange={(v) => setNovaTarefa({...novaTarefa, responsavel_id: v})}
                >
                  <SelectTrigger data-testid="select-tarefa-responsavel">
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                  <SelectContent>
                    {usuarios.map((u) => (
                      <SelectItem key={u.id} value={u.id}>{u.nome}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label>Observações</Label>
                <div className="flex gap-2">
                  <Textarea
                    id="tarefa-obs"
                    placeholder="Observações..."
                    value={novaTarefa.observacoes}
                    onChange={(e) => setNovaTarefa({...novaTarefa, observacoes: e.target.value})}
                    data-testid="input-tarefa-obs"
                    className="flex-1"
                  />
                  <VoiceInput 
                    targetInputId="tarefa-obs"
                    onTranscript={(text) => setNovaTarefa({...novaTarefa, observacoes: novaTarefa.observacoes + ' ' + text})}
                  />
                </div>
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setTarefaModalOpen(false)}>
                Cancelar
              </Button>
              <Button onClick={handleCreateTarefa} disabled={!novaTarefa.titulo} data-testid="btn-salvar-tarefa">
                Criar Tarefa
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
        </div>
      </CardHeader>
      <CardContent>
        {(() => {
          const today = todayLocal();
          const filteredTarefas = tarefas.filter(tarefa => {
            if (tarefaFilter === 'todas') return true;
            
            const isNotCompleted = tarefa.status !== 'concluida' && tarefa.status !== 'cancelada';
            const tarefaDate = tarefa.data_prevista?.split('T')[0];
            
            if (tarefaFilter === 'hoje') {
              return isNotCompleted && tarefaDate === today;
            }
            
            if (tarefaFilter === 'vencidas') {
              return isNotCompleted && new Date(tarefa.data_prevista) < new Date(today);
            }
            
            return true;
          });
          
          if (filteredTarefas.length === 0) {
            return (
              <div className="text-center py-8 text-muted-foreground">
                {tarefaFilter === 'todas' && 'Nenhuma tarefa cadastrada'}
                {tarefaFilter === 'hoje' && 'Nenhuma tarefa para hoje'}
                {tarefaFilter === 'vencidas' && 'Nenhuma tarefa vencida'}
              </div>
            );
          }
          
          return (
            <div className="space-y-3">
              {filteredTarefas.map((tarefa) => {
                const isOverdue = tarefa.status !== 'concluida' && tarefa.status !== 'cancelada' && 
                  new Date(tarefa.data_prevista) < new Date();
                
                return (
                  <div 
                    key={tarefa.id}
                    className={`
                      p-4 rounded-lg border flex flex-col sm:flex-row sm:items-center gap-4
                      ${tarefa.status === 'concluida' ? 'bg-green-50 dark:bg-green-900/10 border-green-200' : ''}
                      ${tarefa.status === 'cancelada' ? 'bg-gray-50 dark:bg-gray-900/10 border-gray-200 opacity-60' : ''}
                      ${isOverdue ? 'border-l-4 border-l-red-500' : ''}
                    `}
                    data-testid={`tarefa-${tarefa.id}`}
                  >
                    <div className="flex-1 space-y-1">
                      <div className="flex items-center gap-2">
                        <span className={`font-medium ${tarefa.status === 'concluida' ? 'line-through' : ''}`}>
                          {tarefa.titulo}
                        </span>
                        <Badge className={PRIORITY_COLORS[tarefa.prioridade]}>
                          {PRIORITY_LABELS[tarefa.prioridade]}
                        </Badge>
                      </div>
                      <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
                        <span>{TASK_TYPE_LABELS[tarefa.tipo]}</span>
                        <span>•</span>
                        <span className={isOverdue ? 'text-red-600 font-medium' : ''}>
                          {formatDate(tarefa.data_prevista)}
                        </span>
                        {tarefa.responsavel_nome && (
                          <>
                            <span>•</span>
                            <span>{tarefa.responsavel_nome}</span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <Select 
                        value={tarefa.status}
                        onValueChange={(v) => handleUpdateTarefaStatus(tarefa.id, v)}
                      >
                        <SelectTrigger className="w-36" data-testid={`select-status-${tarefa.id}`}>
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          {Object.entries(TASK_STATUS_LABELS).map(([value, label]) => (
                            <SelectItem key={value} value={value}>{label}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      <Button 
                        variant="ghost" 
                        size="icon"
                        onClick={() => handleDeleteTarefa(tarefa.id)}
                        data-testid={`btn-delete-tarefa-${tarefa.id}`}
                      >
                        <Trash2 className="h-4 w-4 text-muted-foreground hover:text-red-500" />
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })()}
      </CardContent>
    </Card>
  </TabsContent>
);
